import RudderstackController from './rudderstack_controller'

export default class SwimlaneImpressionController extends RudderstackController {
  static values = {
    eventName: String,
    properties: Object,
  }

  connect() {
    if (!this.hasEventNameValue || !this.hasPropertiesValue) return;
    if (this.propertiesValue.products && this.propertiesValue.products.length === 0) return;

    if (!('IntersectionObserver' in window)) {
      this.track();
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry || !entry.isIntersecting) return;

      this.track();
      this.observer.disconnect();
    }, { threshold: 0.25 });

    this.observer.observe(this.element);
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  track() {
    RudderstackController.track(this.eventNameValue, this.propertiesValue);
  }
}
